/**
 * 港前询价管理前端接口
 */

import { request } from '@/utils/http'
import { type BatchDeleteRequest, type PageResponse } from '@/api/types/common'
import {
  type ShokzInquiryBaseModel,
  type ShokzInquiryPageRequest,
  type ShokzInquirySaveRequest
} from './inquiry-base'

/**
 * 港前询价模型（继承基础询价模型）
 */
export interface ShokzInquiryPrePortModel extends ShokzInquiryBaseModel {
  transportMode?: number | null
  arrivalNodeType?: number | null
  loadingCityId?: string | null
  loadingSeaportId?: string | null
  originCountryId?: string | null
  loadingRailwayStationId?: string | null
  arrivalCountryId?: string | null
  arrivalCityId?: string | null
  arrivalSeaportId?: string | null
  arrivalRailwayStationId?: string | null
  arrivalAirportId?: string | null
  arrivalTerminalId?: string | null
  arrivalAirportTerminal?: string | null
}

/**
 * 港前询价分页查询请求参数
 */
export interface ShokzInquiryPrePortPageRequest extends ShokzInquiryPageRequest {}

/**
 * 港前询价保存请求参数
 */
export interface ShokzInquiryPrePortSaveRequest extends ShokzInquirySaveRequest {
  transportMode?: number | null
  arrivalNodeType?: number | null
  loadingCityId?: string | null
  loadingSeaportId?: string | null
  originCountryId?: string | null
  loadingRailwayStationId?: string | null
  arrivalCountryId?: string | null
  arrivalCityId?: string | null
  arrivalSeaportId?: string | null
  arrivalRailwayStationId?: string | null
  arrivalAirportId?: string | null
  arrivalTerminalId?: string | null
  arrivalAirportTerminal?: string | null
}

export interface ShokzInquirySendEmailRequest {
  inquiryId: string | number
  supplierContactIds: Array<string | number>
}

/**
 * 分页查询港前询价列表
 */
export const pageInquiryPrePort = (params: ShokzInquiryPrePortPageRequest) => {
  return request.post<PageResponse<ShokzInquiryPrePortModel>>(
    '/price/shokzInquiry/pre-port/page',
    params
  )
}

/**
 * 根据ID获取港前询价详情
 */
export const getInquiryPrePortById = (id: string) => {
  // 提取纯数字ID部分，去除可能的额外信息
  const pureId = id.split(/\s+/)[0]
  return request.post<ShokzInquiryPrePortModel>('/price/shokzInquiry/pre-port/get', { id: pureId })
}

/**
 * 根据询价编号获取港前询价详情
 */
export const getInquiryPrePortByInquiryNo = (inquiryNo: string) => {
  return request.post<ShokzInquiryPrePortModel>('/price/shokzInquiry/pre-port/get', { inquiryNo })
}

/**
 * 新增港前询价
 */
export const saveInquiryPrePort = (params: ShokzInquiryPrePortSaveRequest) => {
  return request.post<boolean>('/price/shokzInquiry/pre-port/save', {
    ...params,
    strictRequiredValidation: true
  })
}

/**
 * 修改港前询价
 */
export const updateInquiryPrePort = (params: ShokzInquiryPrePortSaveRequest) => {
  return request.post<boolean>('/price/shokzInquiry/pre-port/update', {
    ...params,
    strictRequiredValidation: true
  })
}

/**
 * 批量删除港前询价
 */
export const batchDeleteInquiryPrePort = (params: BatchDeleteRequest) => {
  return request.post<boolean>('/price/shokzInquiry/pre-port/batch-delete', params)
}

export const sendInquiryEmail = (params: ShokzInquirySendEmailRequest) => {
  return request.post<boolean>('/price/shokzInquiry/pre-port/send-email', params)
}

// 类型别名（兼容老代码）
export type InquiryPrePortModel = ShokzInquiryPrePortModel
export type InquiryPrePortPageRequest = ShokzInquiryPrePortPageRequest
export type InquiryPrePortSaveRequest = ShokzInquiryPrePortSaveRequest
